module.exports = __webpack_public_path__ + "static/media/TitlingGothicFBNormal-Regular.81a5b779.woff";